import React from 'react';
import {
  Box,
  Typography,
  alpha,
  Card,
} from '@mui/material';

const NoHotelSelectedSimple = () => {
  return (
    <Box 
      sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: { xs: 2, sm: 3, lg: 4 },
        textAlign: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      {/* Main Card Container */}
      <Card
        elevation={0}
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: 4,
          position: 'relative',
          overflow: 'hidden',
          bgcolor: 'background.paper',
          boxShadow: theme => `0 2px 8px ${alpha(theme.palette.common.black, 0.03)}`,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Subtle Background Layers */}
        <Box sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.15,
          zIndex: 0,
        }}>
          {/* Layer 1 - Outer */}
          <Box sx={{
            position: 'absolute',
            top: '10%',
            left: '15%',
            width: '70%',
            height: '80%',
            borderRadius: 2,
            background: theme => theme.palette.primary.main,
            opacity: 0.3,
          }} />
          
          {/* Layer 2 - Middle */}
          <Box sx={{
            position: 'absolute',
            top: '15%',
            left: '20%',
            width: '60%',
            height: '70%',
            borderRadius: 4,
            background: theme => theme.palette.primary.main,
            opacity: 0.5,
          }} />
          
          {/* Layer 3 - Inner */}
          <Box sx={{
            position: 'absolute',
            top: '20%',
            left: '25%',
            width: '50%',
            height: '60%',
            borderRadius: 6,
            background: theme => theme.palette.primary.main,
            opacity: 0.7,
          }} />
        </Box>

        {/* Content */}
        <Box sx={{ 
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 3, sm: 4 },
          maxWidth: 500,
        }}>
          {/* Overline */}
          <Typography 
            variant="overline" 
            sx={{ 
              fontFamily: 'StrawberrySansText',
              fontWeight: 600,
              fontSize: '0.7rem',
              letterSpacing: '0.15em',
              color: theme => alpha(theme.palette.text.primary, 0.5),
              mb: 5,
              textTransform: 'uppercase',
            }}
          >
            HOTEL MANAGER
          </Typography>

          {/* Main Heading */}
          <Typography 
            variant="h2" 
            sx={{ 
              fontFamily: 'StrawberrySansDisplay',
              fontWeight: 400,
              fontSize: { xs: '1.75rem', sm: '2.25rem', lg: '2.5rem' },
              lineHeight: 1.2,
              color: 'text.primary',
              mb: 3,
              letterSpacing: '-0.01em',
            }}
          >
            Your portfolio awaits
          </Typography>

          {/* Subtitle */}
          <Typography 
            variant="body1" 
            sx={{ 
              fontFamily: 'StrawberrySansText',
              fontWeight: 400,
              fontSize: { xs: '0.95rem', sm: '1.05rem' },
              lineHeight: 1.6,
              color: theme => alpha(theme.palette.text.primary, 0.6),
              textAlign: 'center',
            }}
          >
            Select any hotel from the sidebar to explore details
          </Typography>
        </Box>
      </Card>
    </Box>
  );
};

export default NoHotelSelectedSimple;

